import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import { API_URL } from "../../config";
import { decode } from "../../utils/encrypt";

function SSORedirect() {
  const history = useHistory();
  const [statusMsg, setStatusMsg] = useState("Verifying...");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(true);

  const verifyCode = (code) => {
    const decodedCode = decode(code);
    fetch(`${API_URL}/iam/sso/dp-check?sso_code=${encodeURIComponent(decodedCode)}`)
      .then((res) => res.json())
      .then((body) => {
        if (body?.success && body?.data?.hasSsoEnabled && body?.data?.dpId) {
          setStatusMsg("Redirecting...");
          window.location.href = `${API_URL}/iam/sso/authorize?dp_id=${body.data.dpId}`;
        } else if (body?.data?.dpId && !body?.data?.hasSsoEnabled) {
          setLoading(false);
          setErrorMsg("SSO is not enabled. Please contact your administrator for assistance.");
        } else {
          setLoading(false);
          setErrorMsg("Invalid link. Please contact your administrator.");
        }
      })
      .catch(() => {
        setLoading(false);
        setErrorMsg("Failed to verify. Please try again.");
      });
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const hostname = window.location.hostname;

    // Step 1: Check if this is a WL domain
    fetch(`${API_URL}/iam/sso/dp-check?dp_domain=${encodeURIComponent(hostname)}`)
      .then((res) => res.json())
      .then((domainBody) => {
        const isWL = !!(domainBody?.data?.dpId);
        const wlHasSSO = !!(isWL && domainBody?.data?.hasSsoEnabled);

        if (code) {
          // Code present — always use code (handles sub-DP on WL domain too)
          verifyCode(code);
          return;
        }

        // No code — fall back to domain-based check
        if (wlHasSSO) {
          setStatusMsg("Redirecting...");
          window.location.href = `${API_URL}/iam/sso/authorize?dp_id=${domainBody.data.dpId}`;
          return;
        }

        if (isWL && !wlHasSSO) {
          setLoading(false);
          setErrorMsg("SSO is not enabled. Please contact your administrator for assistance.");
          return;
        }

        // Non-WL, no code
        history.replace("/login");
      })
      .catch(() => {
        setLoading(false);
        setErrorMsg("Failed to verify. Please try again.");
      });
  }, []);

  return (
    <Grid container justifyContent="center" alignItems="center" style={{ minHeight: "100vh" }}>
      <div style={{ textAlign: "center" }}>
        {loading ? (
          <>
            <CircularProgress />
            <p>{statusMsg}</p>
          </>
        ) : (
          <>
            <p>{errorMsg}</p>
          </>
        )}
      </div>
    </Grid>
  );
}

export default SSORedirect;
